module.exports = window["SSCUIPRO"];